import { Spin, notification } from "antd";
import requestService from "api/request";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [check, setCheck] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();


  const handleForgotPassWord = async () => {
    setLoading(true);
    try {
      const res = await requestService.post("/auth/forgot-password", {
        data: {
          email,
        },
      });
      if (res && res.data) {
        setCheck(res?.data?.data);
      }
    } catch (error: any) {
      console.log(error);

      notification.error({
        message: error?.response?.data?.message,
        duration: 3,
      });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[100vh] bg-v3BgPrimary" data-v-bc61f9fc="">
      <Spin spinning={loading} fullscreen />
      <div className="main-box lay-box clearfix " data-v-bc61f9fc="">
        <div
          className="main-login-wrapper black flex items-center justify-center"
          data-v-6fa5d2d2=""
          data-v-bc61f9fc=""
        >
          {check ? (
            <div className="p-4">
              <div className="text-[#fff] text-[24px] mb-5 text-center">
                {t(
                  "Mật khẩu mới đã được gửi về email . Vui lòng kiểm tra email"
                )}{" "}
                {email}
              </div>
              <div className="flex justify-center">
                <button
                  type="button"
                  className="bit-button max-w-[250px] mx-auto w-full bit-button--chunky bit-button--medium is-round"
                  style={{ boxShadow: "0 4px 0 0 undefined" }}
                  data-v-62803376=""
                  onClick={()=>navigate('/login')}
                >
                  {/**/}
                  {/**/}
                  {/**/}
                  <span> {t("Quay lại")}</span>
                  {/**/}
                </button>
              </div>
            </div>
          ) : (
            <div className="main-login" data-v-6fa5d2d2="">
              <div
                className="container main-box-container main-box-container-login"
                data-v-62803376=""
                data-v-6fa5d2d2=""
              >
                <div className="login-wrap black mainReg" data-v-62803376="">
                  <div className="login-qr-box" data-v-62803376="">
                    {/**/}
                    <div
                      className="clearfix login-title-box"
                      data-v-62803376=""
                    >
                      <h1
                        className="login-qr-title flex justify-center mb-24px"
                        data-v-62803376=""
                      >
                        {t("Quên mật khẩu")}
                      </h1>
                      {/**/}
                    </div>
                    {/**/}
                    <div className="mt-24px" data-v-62803376="">
                      <div className="login-qr-form black" data-v-62803376="">
                        {/* /// Nhập Email hoặc SĐT */}
                        <div
                          className="login-form-group !mb-3"
                          data-v-62803376=""
                        >
                          <label data-v-62803376="">Email</label>
                          <div
                            data-v-4c55cf80=""
                            data-v-62803376=""
                            className="main-login-phone-mail"
                          >
                            <div data-v-4c55cf80="" className="phon-email-wrap">
                              <input
                                data-v-4c55cf80=""
                                type="email"
                                autoComplete="off"
                                name="dnPhone"
                                placeholder={t("Nhập Email Của Bạn")}
                                data-testid="LoginAccountInput"
                                className="input custom-login-input custom-login-input-vi"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        {/* /// Nhập Password */}

                        {/**/}
                        <div data-v-62803376=" " className="!mt-5">
                          <div className="iphone:mt-21px" data-v-62803376="">
                            <button
                              type="button"
                              className="bit-button w-full bit-button--chunky bit-button--medium is-round"
                              style={{ boxShadow: "0 4px 0 0 undefined" }}
                              data-v-62803376=""
                              onClick={handleForgotPassWord}
                            >
                              {/**/}
                              {/**/}
                              {/**/}
                              <span> {t("Gửi")}</span>
                              {/**/}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**/}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
